import axiosInstance from '../api/axios';

export interface AppealAutomationSettings {
  auto_close_enabled: boolean;
  date_update: string;
}

export const appealAutomationSettingsService = {
  async get(): Promise<AppealAutomationSettings> {
    const response = await axiosInstance.get<AppealAutomationSettings>(
      '/appeals/automation-settings'
    );
    return response.data;
  },

  async update(autoCloseEnabled: boolean): Promise<AppealAutomationSettings> {
    const response = await axiosInstance.patch<AppealAutomationSettings>(
      '/appeals/automation-settings',
      { auto_close_enabled: autoCloseEnabled }
    );
    return response.data;
  },
};
